import "./index.css";
import { GravitySlingshot } from "./GravitySlingshot";

export function App() {
	return <GravitySlingshot />;
}

export default App;
